
<template>
  <editor
    apiKey="e3pqje3rewt726shijfdydws9pk223wcls9uy31yqxdj0e0y"
    :init="initial"
    v-model="value"
  />
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import { abstractField } from "vue-form-generator";
import tinymceConfig from "../config/tinymce";
export default {
  mixins: [abstractField],
  components: {
    editor: Editor,
  },
  computed: {
    initial() {
      const baseUrl =
        process.env.NODE_ENV === "production"
          ? "https://nextapi.logonomy.ir"
          : "http://localhost:5051";
      const url = `${baseUrl}/api/Media/EditorUpload/${this.$route.params.module}/${this.$route.params.id}`;

      return tinymceConfig(url);
    }
  },
};
</script>